import React from 'react';
import { useNavigate } from '@/lib/router-compat';
import { Baby, Users, Building2, Zap, Fuel, Mountain } from 'lucide-react';

/**
 * Lifestyle shortcuts — fiecare pill aplică un preset de filtre suportate de /vehicles.
 * Param-urile sunt single-value (ce acceptă acum Vehicles.tsx). Param `intent` e folosit
 * de /vehicles ca să afișeze un badge "Rezultate pentru: <label>".
 */
export const INTENT_PRESETS = [
  { id: 'prima-masina',     icon: Baby,       label: 'Prima mea mașină', qs: 'priceMax=8000&yearMin=2010' },
  { id: 'familie',          icon: Users,      label: 'Mașina de familie', qs: 'bodyType=family&priceMax=20000' },
  { id: 'oras',             icon: Building2,  label: 'Mașina de oraș',    qs: 'bodyType=hatchback&priceMax=12000' },
  { id: 'electric-hibrid',  icon: Zap,        label: 'Electrică / Hibrid', qs: 'fuelType=electric,hibrid,hybrid' },
  { id: 'consum-mic',       icon: Fuel,       label: 'Consum mic',         qs: 'fuelType=diesel' },
  { id: 'offroad-suv',      icon: Mountain,   label: 'Off-road / SUV',     qs: 'bodyType=suv' },
] as const;

export const IntentChips: React.FC = () => {
  const navigate = useNavigate();
  return (
    <div className="-mx-4 px-4 lg:mx-0 lg:px-0 overflow-x-auto lg:overflow-visible scrollbar-hide">
      <div className="flex flex-nowrap lg:flex-wrap gap-2 pb-1 w-max lg:w-auto">
        {INTENT_PRESETS.map(({ id, icon: Icon, label, qs }) => (
          <button
            key={id}
            onClick={() => navigate(`/vehicles?${qs}&intent=${id}#results`)}
            className="shrink-0 whitespace-nowrap inline-flex min-h-[44px] items-center gap-2 px-4 py-2 rounded-full border border-border bg-background text-[hsl(var(--brand-cream))] hover:bg-accent/10 hover:border-accent/40 text-sm font-medium transition-colors"
          >
            <Icon className="h-4 w-4 shrink-0 text-[hsl(var(--brand-cream))]" />
            <span className="text-[hsl(var(--brand-cream))]">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
